import React, { useEffect, useMemo, useState } from "react";
import "./adminDashboard.css";
import { BreadCrumb } from "../../components/breadcrumb/BreadCrumb";
import DefaultLayout from "../../components/layout/DefaultLayout";
import Widget from "../../components/widget/Widget";
import { useDispatch, useSelector } from "react-redux";
import { fetchEnrolsAction } from "../enrolment/enrolmentAction";
import { fetchPreEnrolsAction } from "../pre-enrolment/preEnrolmentAction";
import { fetchCoursesAction } from "../course/courseAction";
import Stats from "../../components/stats/Stats";
import { fetchBlogsAction } from "../blogs/blogAction";
import { Table } from "react-bootstrap";
import { DashboardCurrentCourses } from "../../components/course/DashboardCurrentCourses";

const AdminDashboardPage = () => {
  const dispatch = useDispatch();
  const [enrolments, setEnrolments] = useState([]);
  const [preEnrols, setPreEnrols] = useState([]);
  const [blgs, setBlgs] = useState([]);
  const [crs, setCrs] = useState([]);
  const { enrollments } = useSelector((state) => state.enroll);
  const { preEnrolments } = useSelector((state) => state.preEnrol);
  const { courses } = useSelector((state) => state.course);
  const { blogs } = useSelector((state) => state.blog);
  const { user } = useSelector((state) => state.user);

  const params = useMemo(() => {
    const p = new URLSearchParams();
    p.set("branch", user?.branch);
    return p;
  }, [user?.branch]);

  useEffect(() => {
    dispatch(fetchEnrolsAction(params.toString()));
    dispatch(fetchPreEnrolsAction(params.toString()));
    dispatch(fetchCoursesAction(params.toString()));
    dispatch(fetchBlogsAction());
  }, [dispatch, params]);

  useEffect(() => {
    setEnrolments(enrollments);
    setPreEnrols(preEnrolments);
    setCrs(courses);
    setBlgs(blogs);
  }, [enrollments, preEnrolments, courses, blogs]);

  const noOfEnrolments = enrolments?.length;
  const noOfPreEnrolments = preEnrols?.length;
  const noOfCourses = crs?.length;
  const noOfBlogs = blgs?.length;

  return (
    <DefaultLayout>
      <BreadCrumb label="Dashboard" />

      <div className="widgets">
        <Widget type="enrolment" noOfEnrolments={noOfEnrolments} />
        <Widget type="pre-enrolment" noOfPreEnrolments={noOfPreEnrolments} />
        <Widget type="course" noOfCourses={noOfCourses} />
        <Widget type="blog" noOfBlogs={noOfBlogs} />
      </div>
      <div className="currentClass mt-5 mb-5">
        <DashboardCurrentCourses courses={courses} />
      </div>
      <div className="charts">
        <Stats />
      </div>
    </DefaultLayout>
  );
};

export default AdminDashboardPage;
